import React, { useState, useEffect } from 'react';

const minuteSeconds = 60;
const hourSeconds = 3600;
const daySeconds = 86400;

const CountdownPreview = ({ expiryDate, auctionStatus }) => {
    const calculateTimeLeft = () => {
        const startTime = Date.now() / 1000; // Timestamp in secondi
        const endTime = new Date(expiryDate).getTime() / 1000; // Timestamp in secondi
        const remainingTime = endTime - startTime;
        return {
            days: Math.floor(remainingTime / daySeconds),
            hours: Math.floor((remainingTime % daySeconds) / hourSeconds),
            minutes: Math.floor((remainingTime % hourSeconds) / minuteSeconds),
            seconds: Math.floor(remainingTime % minuteSeconds),
            expired: remainingTime <= 0,
        };
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        if (auctionStatus === 'completed') {
            // Non fare nulla se l'asta è completata
            return;
        }

        const interval = setInterval(() => {
            const updatedTime = calculateTimeLeft();
            setTimeLeft(updatedTime);
        }, 1000);

        return () => clearInterval(interval); // Pulizia dell'intervallo al termine
    }, [expiryDate, auctionStatus]);

    // Se l'asta è completata o il tempo è scaduto, non renderizzare il countdown
    if (auctionStatus === 'completed' || timeLeft.expired) {
        return null;
    }

    // Se il tempo è scaduto, mostra la scritta "Scaduto"
    if (timeLeft.expired) {
        return (
            <div className="flex items-center justify-center w-full h-6 border-burnt-coffee rounded-md bg-burnt-coffee text-lg py-3.5">
                <span className="font-heading font-semibold text-white">Scaduto</span>
            </div>
        );
    }

    // Funzione per formattare i numeri aggiungendo uno zero davanti se necessario
    const formatTime = (time) => time.toString().padStart(2, '0');

    return (
        <div className="flex items-center px-2 justify-center w-full h-6 border-burnt-coffee rounded-md bg-burnt-coffee text-md py-3.5">
            <div className="flex items-center pt-0.5">
                <span className="font-heading font-base text-white">{formatTime(timeLeft.days)}</span>
            </div>
            <span className="font-heading text-white pt-0.5">:</span>
            <div className="font-heading font-base text-white pt-0.5">
                <span>{formatTime(timeLeft.hours)}</span>
            </div>
            <span className="font-heading text-white pt-0.5">:</span>
            <div className="font-heading font-base text-white pt-0.5">
                <span>{formatTime(timeLeft.minutes)}</span>
            </div>
            <span className="font-heading text-white pt-0.5">:</span>
            <div className="font-heading font-base text-white pt-0.5">
                <span>{formatTime(timeLeft.seconds)}</span>
            </div>
        </div>
    );
};

export default CountdownPreview;
